import { Buttons, CancelButton, Drawer, Form } from '~/components';
import { useDocumentTitle } from '~/hooks';
import React from 'react';
import ReadTextbox from '~/components/read-only/ReadTextbox';

function OpportunityPipelineDrawerView({ opportunityPipeline, onClose }) {
  const title = 'View Opportunity Pipeline';
  useDocumentTitle(title);

  function handleClose() {
    if (onClose) {
      onClose();
    }
  }

  return (
    <Drawer isOpen title={title} byline="Custom Data" onClose={handleClose}>
      <Form.Section title="Details">
        <Form.Control>
          <ReadTextbox label="Name" value={opportunityPipeline.name} />
        </Form.Control>
        <Form.Control>
          <ReadTextbox label="Description" value={opportunityPipeline.description} textarea />
        </Form.Control>
      </Form.Section>

      <Drawer.Actions>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Close</CancelButton>
        </Buttons>
      </Drawer.Actions>
    </Drawer>
  );
}

export default OpportunityPipelineDrawerView;
